import { TerminZaznamySekcieUpdateApi, ZaznamSekcie } from 'tezaury-frontend-ts-axios';
import { AxiosRequestHeaders } from 'axios';
import apiConfiguration from '../configuration/apiConfiguration';
import { ClientResponse } from '../../model/ClientResponse';
import Uuid from '../../model/Uuid';
import { tezauryPrefixPath } from '../configuration/apiConfigurationConstants';

const client = new TerminZaznamySekcieUpdateApi(apiConfiguration(tezauryPrefixPath));

// eslint-disable-next-line import/prefer-default-export
export const updateTerminZaznamySekcie = async (
  terminUuid: Uuid,
  zaznamySekcie: Array<ZaznamSekcie>,
  options: { headers?: AxiosRequestHeaders } = {},
): Promise<ClientResponse<void>> => {
  const { data, status } = await client.updateTerminZaznamySekcie(terminUuid, zaznamySekcie, options);
  return { data, responseCode: status };
};
